import config from "@repo/sitecore-lib/config";

export const getSitecoreGraphEndpoint = (
  host = config.sitecoreApiHost,
): string => {
  const params = new URLSearchParams();
  params.append("sc_apikey", config.sitecoreApiKey);

  /**
   * Append specific x-site-origin for local development when HACK_SITECORE_X_SITE_ORIGIN is set.
   * On PROD ChameleonRequest will inject the x-site-origin from the incoming request using the cookie.
   */
  if (process.env.HACK_SITECORE_X_SITE_ORIGIN === "true") {
    params.append("x-site-origin", "env02pt.asosdevelopment.com");
  }

  return `${host}/sitecore/api/graph/edge?${params.toString()}`;
};
